import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react'
import {
  Wrapper,
  Container,
  MenuContainer,
  Expand,
  Logo,
  Menu,
  MenuItem,
  Icon,
  Label,
  Links,
  Footer,
  Divider,
  AvatarPic,
  ProfileContainer,
  Header,
  Body,
  Wallet
} from './styled'
import { useTranslation } from 'react-i18next'
import { imageBaseUrl } from '../../config'
import { useDispatch, useSelector } from 'react-redux'
import { retrieveUserData } from '../../actions/user'
import { retriveWallet } from '../../actions/financial'
import { Istate } from '../../reducers/types'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { getNotificationsRequest } from '../../api/profile'
import {
  SmallHeader,
  Section,
  SectionName,
  Sections,
  WalletData,
  LargeHeader,
  menuItemType,
  menuItemsType
} from './Components'
import { sidebarMenu } from '../../tools/sidebarMenu'
import { Tooltip, CompleteProfileInfo } from '@sabavision/dio'

const Sidebar = forwardRef((props: any, ref: any) => {
  useImperativeHandle(ref, () => ({
    openDeposit() {
      setOpenProfileMenu(true)
      setTimeout(() => {
        setOpenDataSection({
          open: true,
          section: {
            label: 'واریز',
            name: 'deposit',
            icon: 'iconsax-money-add'
          }
        })
      }, 500)
    }
  }))
  const { t } = useTranslation('translation', { keyPrefix: 'sidebar' })
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const { userId } = useParams()
  const clickOutside = useRef(null)
  const user = useSelector((state: Istate) => state.user)
  const owner = useSelector((state: Istate) => state.owner)
  const [flag, setFlag] = useState<boolean>(false)
  const [profileButtons, setProfileButtons] = useState<menuItemsType[]>([
    {
      label: 'پروفایل',
      name: 'profile',
      icon: 'iconsax-profile-circle',
      disabled: false,
      badge: 0
    },
    {
      label: 'اطلاعات مالی',
      name: 'financialData',
      icon: 'iconsax-receipt-2',
      disabled: false,
      badge: 0
    },
    {
      label: 'واریز',
      name: 'deposit',
      icon: 'iconsax-money-add',
      disabled: false,
      badge: 0
    },
    {
      label: 'تنظیمات',
      name: 'setting',
      icon: 'iconsax-setting-3',
      disabled: false,
      badge: 0
    },
    {
      label: 'پیام‌ها',
      name: 'messages',
      icon: 'iconsax-messages',
      disabled: false,
      badge: 0
    },
    {
      label: 'راهنمای پنل',
      name: 'guide',
      icon: 'iconsax-video-square',
      disabled: false,
      badge: 0
    }
  ])

  useEffect(() => {
    if (user.unique_id.length) {
      setProfileButtons([
        {
          label: 'پروفایل',
          name: 'profile',
          icon: 'iconsax-profile-circle',
          disabled: false,
          badge: 0
        },
        {
          label: 'اطلاعات مالی',
          name: 'financialData',
          icon: 'iconsax-receipt-2',
          disabled: false,
          badge: 0
        },
        {
          label: 'واریز',
          name: 'deposit',
          icon: 'iconsax-money-add',
          disabled: !(user.type === 'advertiser' && user.verification_status === 'verified'),
          badge: 0
        },
        {
          label: 'تنظیمات',
          name: 'setting',
          icon: 'iconsax-setting-3',
          disabled: false,
          badge: 0
        },
        {
          label: 'پیام‌ها',
          name: 'messages',
          icon: 'iconsax-messages',
          disabled: false,
          badge: 0
        },
        {
          label: 'راهنمای پنل',
          name: 'guide',
          icon: 'iconsax-video-square',
          disabled: false,
          badge: 0
        }
      ])
      setFlag(true)
    }
  }, [user.unique_id])

  useEffect(() => {
    if (user.unique_id.length && flag) {
      dispatch(retriveWallet(user.unique_id))
      handleGetMessagesRequest()
      setFlag(false)
    }
  }, [flag])

  useEffect(() => {
    if (userId !== user.unique_id) {
      dispatch(retrieveUserData(userId))
    }
  }, [userId])

  const [open, setOpen] = useState<boolean>(false)
  const openMenu = () => {
    setOpen(!open)
  }

  const [openProfileMenu, setOpenProfileMenu] = useState<boolean>(false)
  const openProfile = (e: any) => {
    e.stopPropagation()
    setOpenProfileMenu(!openProfileMenu)
    setOpenDataSection({
      open: false,
      section: { name: '', label: '', icon: '' }
    })
  }

  const [openDataSection, setOpenDataSection] = useState<{ open: boolean; section: menuItemType }>({
    open: false,
    section: { name: '', label: '', icon: '' }
  })

  const closeSection = () => {
    setOpenDataSection({ ...openDataSection, open: false })
  }

  const openSection = (item: menuItemsType) => {
    if (item.name === 'guide') {
      window.open('https://www.aparat.com/playlist/1798832')
      return
    }
    setOpenDataSection({ open: true, section: item })
  }

  const handleClickOutside = (event?: any, ref?: any) => {
    event.stopPropagation()
    if (event.target === ref.current) {
      setOpen(false)
      setOpenProfileMenu(false)
      setOpenDataSection({
        open: false,
        section: { name: '', label: '', icon: '' }
      })
    }
  }

  const handleGetMessagesRequest = () => {
    getNotificationsRequest(
      userId,
      {},
      (response) => {
        const counter = response.filter((item: any) => !item.read_at)
        const temp: any = [...profileButtons]
        temp[4].badge = counter.length
        setProfileButtons([...temp])
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  return (
    <Wrapper dir="rtl">
      <Container
        className={`${openProfileMenu ? 'open' : ''}`}
        ref={clickOutside}
        onClick={(event) => {
          handleClickOutside(event, clickOutside)
        }}
      >
        <MenuContainer dir="rtl" className={`${open ? 'open' : ''}`}>
          <Logo>
            <img
              className="logo"
              src={`${imageBaseUrl}/images/logo/${open ? 'vplus-logo-with-typography-en' : 'sabavision-logo'}.svg`}
            />
          </Logo>
          <Expand>
            <img
              src={`${imageBaseUrl}/images/${open ? 'expand-2' : 'expand-1'}.svg`}
              onClick={() => {
                openMenu()
              }}
            />
          </Expand>
          <Menu>
            {sidebarMenu(userId).map((item, index) => {
              return open ? (
                <MenuItem
                  key={index}
                  className={`${location.pathname.includes(item.activePath) ? 'menu-item item active' : 'menu-item item'}`}
                  onClick={() => {
                    navigate(item.path)
                  }}
                >
                  <Icon className={item.icon}></Icon>
                  <Label className="label">{item.label}</Label>
                </MenuItem>
              ) : (
                <Tooltip text={item.label}>
                  <MenuItem
                    key={index}
                    className={`${location.pathname.includes(item.activePath) ? 'menu-item item active' : 'menu-item item'}`}
                    onClick={() => {
                      navigate(item.path)
                    }}
                  >
                    <Icon className={item.icon}></Icon>
                    <Label className="label">{item.label}</Label>
                  </MenuItem>
                </Tooltip>
              )
            })}
          </Menu>
          <Footer className="footer">
            <div className="footer-container">
              {owner.type === 'admin' && !open ? (
                <MenuItem style={{ cursor: 'default' }}>
                  <div className="in-person">
                    <Label>
                      {user.entity_type === 'legal_person'
                        ? `${user.company_name}`
                        : `${user.first_name} ${user.last_name}`}
                    </Label>
                  </div>
                  <div></div>
                </MenuItem>
              ) : null}
              <MenuItem
                id="toggle_chat"
                className="item toggle_chat"
                onClick={() => {
                  console.log()
                }}
              >
                <Icon className="iconsax-headphone" />
                <Label className="label">{t('support')}</Label>
              </MenuItem>
              <Divider className="divider"></Divider>
              <MenuItem
                className="item profile"
                onClick={() => {
                  console.log()
                }}
              >
                <AvatarPic onClick={openProfile}>
                  {user?.avatar?.url ? (
                    <img src={user.avatar.url} alt={user.first_name} />
                  ) : (
                    <Icon className="iconsax-user icon"></Icon>
                  )}
                  {user.prefer_receive_notifications_over_sms ? <div></div> : null}
                  {profileButtons[4].badge ? <div></div> : null}
                </AvatarPic>
                <Label className="label name" style={{ color: '#645F5F' }} onClick={openProfile}>
                  {user.first_name}
                </Label>
                {openProfileMenu && <Icon className="iconsax-arrow-right-3 indicator"></Icon>}
              </MenuItem>
            </div>
          </Footer>
        </MenuContainer>
        <ProfileContainer className={openProfileMenu ? 'open' : ''}>
          <div className="menu">
            <Header
              className="open"
              style={{
                background: `#fff url(${imageBaseUrl}/images/background/wave-form2.svg)`,
                width: 'calc(100% - 3px)'
              }}
            >
              <LargeHeader />
            </Header>
            <Body>
              <Wallet className="wallet-data">
                <WalletData
                  openSection={(item) => {
                    openSection(item)
                  }}
                />
              </Wallet>
              <Sections
                profileButtons={profileButtons}
                openSection={(item) => {
                  openSection(item)
                }}
              />
            </Body>
            {user.verification_status === 'completing_profile' ? (
              <div style={{ paddingInline: '57.5px' }}>
                <CompleteProfileInfo message={t('messages.completing_profile')} disabled></CompleteProfileInfo>
              </div>
            ) : user.verification_status === 'awaiting_approval' ? (
              <div style={{ paddingInline: '57.5px' }}>
                <CompleteProfileInfo message={t('messages.awaiting_approval')} disabled></CompleteProfileInfo>
              </div>
            ) : null}
            <Links>
              <img src={`${imageBaseUrl}/images/logo/vplus-logo-with-typography-en.svg`} />
              <div className="social-addresses">
                <span
                  className="dio-twitter"
                  onClick={() => window.open('https://www.twitter.com/sabavisioncom', '_blank')}
                />
                <span
                  className="dio-aparat"
                  onClick={() => window.open('https://www.aparat.com/SabaVision', '_blank')}
                />
                <span
                  className="dio-instagram"
                  onClick={() => window.open('https://www.instagram.com/sabavision', '_blank')}
                />
                <span
                  className="dio-linkedin"
                  onClick={() => window.open('https://www.linkedin.com/company/sabavisioncom-agency', '_blank')}
                />
              </div>
            </Links>
          </div>

          <div className={`${openDataSection.open ? 'sections open' : 'sections'}`}>
            <Header
              className="close"
              style={{
                background: `#fff url(${imageBaseUrl}/images/background/wave-form1.svg)`,
                width: 'calc(100% - 3px)'
              }}
            >
              <SmallHeader closeSection={closeSection} />
            </Header>
            <Body>
              <Wallet className="section-name">
                <SectionName section={openDataSection.section} />
              </Wallet>
              <Section sectionName={openDataSection.section.name} closeSection={closeSection} />
            </Body>
            <div></div>
          </div>
        </ProfileContainer>
      </Container>
    </Wrapper>
  )
})

Sidebar.displayName = 'Sidebar'

export default Sidebar
